import { Component, Input } from '@angular/core';
import { AssessmentReportTemplate, IReport } from '@interfaces/index';
import { applyFallbacks, normalizeFacilitatorReport } from './utils/report.utils';
import { getStyles } from './styles';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent {
  AssessmentReportTemplate = AssessmentReportTemplate;

  @Input() download = false;
  private _report: IReport | null = null;

  @Input()
  set report(value: IReport | null) {
    if (!value) {
      this._report = null;
      return;
    }

    applyFallbacks(value);

    if (value.templateId === AssessmentReportTemplate.FacilitatorStyles) {
      this._report = normalizeFacilitatorReport(value);
    } else {
      this._report = value;
    }

    this.setStyleExpression(value);
  }

  get report(): IReport | null {
    return this._report;
  }

  get isFacilitatorTemplate(): boolean {
    return this._report?.templateId === AssessmentReportTemplate.FacilitatorStyles;
  }

  get styles(): any {
    return getStyles(this.download);
  }

  private setStyleExpression(value: IReport): void {
    if (!value.styleExpression && value.graph?.DirectIndirect?.scores?.length === 2) {
      const [rawDirect, rawIndirect] = value.graph.DirectIndirect.scores;
      const direct = parseFloat(String(rawDirect ?? '0'));
      const indirect = parseFloat(String(rawIndirect ?? '0'));
      value.styleExpression = direct >= indirect ? 'Direct' : 'Indirect';
      value.styleExpressionDesc = `You tend to express yourself in a ${value.styleExpression === 'Direct' ? 'more direct' : 'more indirect'} manner.`;
    }
  }
}
